__turbopack_context__.v({
  "container": "QuantitySelector-module-scss-module__9Vv1dW__container",
  "dropdown": "QuantitySelector-module-scss-module__9Vv1dW__dropdown",
  "label": "QuantitySelector-module-scss-module__9Vv1dW__label",
  "minQuantityMessage": "QuantitySelector-module-scss-module__9Vv1dW__minQuantityMessage",
});
